const i_agree = {
  title: {
    en: "Agree",
    rw: "Emeza",
  },
  type: "checkbox",
  name: "agree",
  isRequired: true,
  choices: [
    {
      value: {
        en: "Applicant has agreed to loan amount, loan terms and total fees",
        rw: "needs translation",
      },
      text: {
        en: "I agree",
        rw: "Ndabyemeye",
      },
    },
  ],
  validators: [],
};

const current_date = {
  type: "expression",
  title: "",
  titleLocation: "none",
  name: "today_date",
  expression: `daysFromNow(0, 0, 'rw')`,
};

const terms_and_conditions = {
  title: {
    en: "Terms and conditions",
    rw: "Amategeko n'amabwiriza",
  },
  name: "loan",
  elements: [
    {
      name: "insurance",
      type: "panel",
      innerIndent: 1,
      elements: [
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `<h3>Introduction</h3><br>
                  The Kwihaza Interest Rate Subsidy (IRS) Scheme is a strategic initiative led by Access to Finance Rwanda (AFR) aimed at enhancing access to affordable finance 
                  for actors in selected agricultural value chains. Through targeted interest rate subsidies, the scheme addresses high borrowing costs that constrain productivity and 
                  investment, particularly for smallholder farmers, cooperatives, and agri-MSMEs. `,
            rw: `<h3>Intangiriro</h3><br>
                  Gahunda ya Kwihaza Inkunga ku Rugero rw'Inguzanyo (IRS) ni gahunda y'ingamba iyobowe na Access to Finance Rwanda (AFR) igamije kunoza uburyo bwo kubona inguzanyo 
                  ihendutse ku bakora mu buhinzi bwatoranyijwe. Binyuze ku nyungu igabanyije ku nguzanyo, iyi gahunda izakemura ikiguzi kinini ku nguzanyo kibangamira umusaruro n'ishoramari, 
                  cyane cyane ku bahinzi bato, amakoperative, n'ibigo bito n'ibiciriritse bikora  mu buhinzi.`,
          },
        },
        {
          type: "html",
          title: "",
          visibleIf:
            "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I, the undersigned, hereby declare the validity and accuracy of the above-mentioned information, data and documents
                  provided by me to MoneyPhone Africa Ltd., the Lender, and that they are identical to my personal information and have
                  been filled out by me personally with my full legal capacity, my freedom and my will.`,
            rw: `Njyewe, nemeje ko amakuru nahaye MoneyPhone Africa Ltd ko ari ukuri , kandi ko ntanze amakuru yanjye bwite kandi
                  yujujwe nanjye mu mudendezo no kubushake bwanjye  mu uburyo bwemewe n'amategeko.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `<h3>Terms and Conditions</h3><br>
                  I, the undersigned, hereby declare the validity and accuracy of the above-mentioned 
                  information, data, and documents provided by me to MoneyPhone Africa Ltd., the Lender, 
                  and confirm that they correspond to my personal and business information, have been provided by me personally, and are submitted with full legal capacity, 
                  freely and voluntarily. `,
            rw: `<h3>Amategeko n'amabwiriza</h3><br>
                 Jyewe ,washyizeho umukono, ndemeza ko amakuru, inyandiko nahaye MoneyPhone Africa Ltd, Uguriza, ko ari ukuri kandi zihuye cg zerekana imyirondoro yanjye
                 n’iy’ubucuruzi  zikaba zatanzwe nanjye  kandi ku bushake bwanjye, nta gahato.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} != 'tea' and {loan_purpose} != 'coffee' and {loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato'" +
            " and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I, the undersigned, declare that I have no objection to Lender inquiring and/or viewing and/or providing and/or exchanging
                  credit information and/or other information about me with credit information companies, and the exchange of any of the
                  information provided by me and any other relevant data with the Central Bank, BRD and/or any other related parties as of its
                  date without the Lender bearing any legal responsibility for that, and I acknowledge the right The Lender may request
                  any additional information and/or documents at any time, or review one of its branches if necessary.`,
            rw: `Nemeye kandi ndumva neza ko nta nzitizi mfite ko MoneyPhone yagenzura cyangwa yabaza/yatanga amakuru ku nguzanyo yanjye
                  ku bigo bishinzwe kugenzura inguzanyo ndetse na bank nkuru y'igihugu cyangwa bank itsura amajyambere (BRD), Nemeye ko MoneyPhone yansaba andi makuru
                  yose ajyanye n'ubusabe bw'inguzanyo yanjye igihe ari cyose iyakeneye.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan_purpose} == 'tea' or {loan_purpose} == 'coffee'",
          html: {
            en: `I, the undersigned, declare that I have no objection to Lender inquiring and/or viewing and/or providing and/or exchanging
                  credit information and/or other information about me with credit information companies, and the exchange of any of the
                  information provided by me and any other relevant data with the Central Bank and/or any other related parties as of its
                  date without the Lender bearing any legal responsibility for that, and I acknowledge the right The Lender may request
                  any additional information and/or documents at any time, or review one of its branches if necessary.`,
            rw: `Nemeye kandi ndumva neza ko nta nzitizi mfite ko MoneyPhone yagenzura cyangwa yabaza/yatanga amakuru ku nguzanyo yanjye
                  ku bigo bishinzwe kugenzura inguzanyo ndetse na bank nkuru y'igihugu, Nemeye ko MoneyPhone yansaba andi makuru
                  yose ajyanye n'ubusabe bw'inguzanyo yanjye igihe ari cyose iyakeneye.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I {first_name} {last_name}, confirm that I have applied for a loan amount of {requested_amount} RWF at an annual market interest rate of 20% with an annual subsidized 
                  rate of 8%  from AFR and 2% annual subsidy of MoneyPhone for a period of 0.5 years. `,
            rw: `Jye {first_name} {last_name} ndemeza kandi ko nasabye inguzanyo ya RWF {requested_amount} ku nyungu ya 20% ku mwaka hamwe n’ikigeranyo cy’inyungu cya 8%
                 y’inkunga ya AFR hamwe n’ikigeranyo cy’inyungu  2% y’inkunga ya MoneyPhone ku mwaka mu gihe cy'amezi atandatu (6). `,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I, the undersigned, declare that I have no objection to the Lender inquiring, viewing, providing, and/or exchanging credit information and 
                  other relevant information about me with credit information companies, the Central Bank, Access to Finance Rwanda (AFR), AFR funders, and 
                  other legally authorized parties, for purposes of loan assessment, administration, implementation of interest rate subsidies, monitoring, 
                  reporting, and compliance. I acknowledge the right of the Lender to request additional information and/or documents at any time. `,
            rw: `Jyewe, uwasinye, ndemeza ko nta kibazo mfite ku bijyanye n’uko Utanga inguzanyo yabaza, yureba, yatanga, cyangwa yhanahana amakuru y’inguzanyo
                 n’andi makuru ajyanye nanjye n’ibigo bitanga amakuru ku nguzanyo, Banki Nkuru y’igihugu, Access to Finance Rwanda (AFR), abaterankunga ba AFR, 
                 n’abandi bantu bemewe n’amategeko, mu rwego rwo gusuzuma inguzanyo, kuyobora, gushyira mu bikorwa inkunga ku nyungu, gukurikirana, gutanga raporo,
                 no kubahiriza amategeko. Ndemera  ko nzi uburenganzira bw’Utanga inguzanyo bwo gusaba andi makuru cyangwa inyandiko igihe cyose biri ngombwa.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I acknowledge that I am fully aware of all administrative and legal consequences of failure to repay the loan on time. `,
            rw: `Ndemera ko nzi neza ingaruka zose zo mur rwego rw’ubuyobozi n’iz’amategeko zo kutishyura inguzanyo ku gihe.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I declare that I have inquired into and fully understand all financing conditions, interest rates, prices, administrative expenses, and terms and
                  conditions applicable to the loan, including where applicable the application of an interest rate subsidy under the Kwihaza Interest Rate Subsidy (IRS) 
                  Scheme implemented by Access to Finance Rwanda (AFR). `,
            rw: `Ndemeza ko nabajije kandi nsobanukiwe neza ibisabwa byose mu bijyanye n’imari, inyungu, ibiciro, amafaranga yo mu rwego rw’ubuyobozi, n’amahame n’amabwiriza 
                 agenga inguzanyo, harimo no gusaba inkunga ku nyungu muri gahunda y’inkunga ya Kwihaza ku nyungu igabanyije (IRS) ishyirwa mu bikorwa na Access to Finance Rwanda (AFR).`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I declare that all copies of documents uploaded through the website or electronic application are true copies and that all data provided by me is accurate and
                 provided under my responsibility. `,
            rw: `Ndemeza ko kopi zose z’inyandiko zashyizwe ku rubuga cyangwa porogaramu y’ikoranabuhanga isabirwaho inguzanyo ari kopi nyazo kandi ko amakuru yose natanze ari
                 ukuri kandi atangwa ku bushake bwanjye zanjye.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I acknowledge that I have read and agreed to the terms, conditions, and privacy policy provided by the Lender, MoneyPhone Africa Ltd. `,
            rw: `Ndemera ko nasomye kandi nemeranya n’amategeko n'amabwiriza,  hamwe na gahunda y’amakuru y’ubuzima bwite yatanzwe n'utanga inguzanyo,ariwe MoneyPhone Africa Ltd.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I further acknowledge that where my loan benefits from the Kwihaza Interest Rate Subsidy (IRS) Scheme, the loan is provided at a market interest rate 
                  with a subsidy applied in accordance with the Scheme’s rules. `,
            rw: `Nongeye kwemera kandi ko  inguzanyo yanjye yungukira muri gahunda y’inyungu igabanjye ya Kwihaza Inyungu (IRS), inguzanyo yanjye yatanzwe ku nyungu cg ku
                 giciro kuri ku isoko ikaba ihabwa inkunga hakurikijwe amategeko n’amabwiriza bya gahunda ya Kwihaza. `,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I hereby consent to the collection, processing, use, storage, and sharing of my personal and business information by MoneyPhone Africa Ltd., 
                  Access to Finance Rwanda (AFR), and AFR funders, solely for purposes related to the Kwihaza IRS Scheme, including verification of eligibility and 
                  compliance, administration of the subsidy, monitoring and evaluation of outcomes and impact, reporting, surveys, learning products, publications, 
                  and ensuring compliance with applicable environmental and social standards. `,
            rw: `Ndemera kandi ko amakuru yanjye bwite n'ay'ubucuruzi akusanywa, akoreshwa abikwa, ahererekanywa na MoneyPhone Africa Ltd., Access to Finance Rwanda (AFR),
                 n'abaterankunga ba AFR, muri gahunda za  Kwihaza gusa, harimo no kugenzura  ibisabwa, kubahiriza, gucunga inkunga, gukurikirana no gusuzuma ibyavuye mu 
                 bushakashatsi n'ingaruka, gutanga raporo, ubushakashatsi, kwiga ibicuruzwa, gutangaza, no kugenzura ko amahame agenga ibidukikije n'imibereho myiza yubahirizwa.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I understand that data processed for these purposes may include identification and contact details, loan and repayment information, business or 
                  agricultural activity information, and other relevant financial, operational, environmental, or social data required for implementation and reporting. `,
            rw: `Ndumva ko amakuru atunganywa muri izi mpamvu  ashobora kuba arimo amakuru yerekeye imyirondoro cg amakuru ya telefoni, amakuru yerekeye inguzanyo no kwishyura, 
                 amakuru y'ibikorwa by'ubucuruzi cyangwa ubuhinzi, n'andi makuru y'imari, imikorere, ibidukikije, cyangwa imibereho akenewe kugira mu gushyira mu bikorwa cyangwa
                 no gutanga raporo.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I acknowledge that my data may be securely stored and processed, and aggregated or anonymized for reporting and 
                  learning purposes. Identifiable information will only be published externally with my explicit consent. `,
            rw: `Ndemera ko amakuru yanjye ashobora kubikwa neza kandi agatunganywa, agashyirwa hamwe cyangwa agashyirwa ku mugaragaro mu gutanga raporo cywangwa kwiga.
                 Amakuru azwi azatangazwa gusa hanze ari uko nabitangiye uburenganizira.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `I acknowledge that I have the right to access, correct, or request deletion of my personal data in accordance with applicable data protection laws, 
                  and that I may withdraw my consent at any time by contacting AFR’s Data Protection Officer at dataprotection@afr.rw. Withdrawal of consent will apply 
                  to future processing and will not affect lawful processing already undertaken. `,
            rw: `Ndemera ko mfite uburenganzira bwo kubona, gukosora, cyangwa gusaba gusiba amakuru yanjye bwite hakurikijwe amategeko agenga kurengera amakuru,
                 kandi ko nshobora gukuraho uburenganzira natanze  igihe ari uko mvuganye n'ushinzwe kurengera amakuru kigo cya AFR kuri dataprotection@afr.rw.
                 Gukuraho uburenganzira bireba  ibyakorwa mu gihe kizaza,  kandi ntibizagira ingaruka ku byakozwe cyera.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} == 'onion' or {loan_purpose} == 'avocado' or {loan_purpose} == 'tomato' or {loan_purpose} == 'fish' or {loan_purpose} == 'passion_fruit'",
          html: {
            en: `By accepting these Terms and Conditions electronically, I confirm that I have read, understood, and consent to the above. `,
            rw: `Nemeye aya mabwiriza n'Amategeko mu buryo bw'ikoranabuhanga, kandi ndemeza ko nasomye, nasobanukiwe, kandi nemera ibyavuzwe haruguru.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I also acknowledge that I made the inquiry and that I am fully aware of all the administrative and legal aspects of failure to pay on time.`,
            rw: `Ndemera kandi  nzi neza ibijyanye n'amabwiriza n'amategeko byose bijyanye no kutishyurira ku gihe inguzanyo nsabye.`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I also declare that I have inquired and that I am fully aware of all financing conditions, prices, administrative expenses,
                  terms and conditions of use.`,
            rw: `Ndemeza ko nabajije kandi nzi neza  ibiciro byose by'iyi nguzanyo, umufuragiro, inyungu k'unguzanyo nandi mabwiriza yo
                  gukoresha iyi nguzanyo`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I declare that all copies of the attached documents that have been attached to the website/electronic application are
                  true copies and that all edited data are written by me, correct and under my responsibility.`,
            rw: `Ndemeza ko kopi zose zinyandiko nometse kurubuga  rwa MoneyPhone ari kopi zukuri kandi ko amakuru yose yahinduwe
                  yanditswe nanjye kandi ari ukuri`,
          },
        },
        {
          type: "html",
          visibleIf:
            "{loan_purpose} != 'onion' and {loan_purpose} != 'avocado' and {loan_purpose} != 'tomato' and {loan_purpose} != 'fish' and {loan_purpose} != 'passion_fruit'",
          html: {
            en: `I acknowledge that I have read and agreed to the terms, conditions and privacy policy provided to me by the Lender,
                  MoneyPhone Africa Ltd.`,
            rw: `Nemeye ko nasomye kandi nemera amabwiriza y'iyinguzanyo MoneyPhone Africa Ltd impaye.`,
          },
        },
        {
          type: "html",
          html: {
            en: `<h3>Loan Agreement Insurance Information</h3><br>
                  I, the undersigned, acknowledge and agree that this loan includes automatic insurance coverage provided by Sanlam Vie PLC. This insurance covers specific events, including the death or total and permanent disability of the borrower, for the purpose of supporting the repayment of the outstanding loan balance.<br><br>
                  I understand that the insurance premiums are included in my loan repayments and that no separate payments are required. In the event of a covered incident, I undertake to promptly notify the Lender or the Insurer and to cooperate fully in the claims process as set out under the applicable insurance policy.<br><br>
                  I further acknowledge that the insurance coverage is subject to the terms, limitations, and exclusions stipulated in the relevant policy documentation.<br><br> 
                  Should I require any clarification or additional information regarding the scope or conditions of the insurance coverage, I may contact the Lender for assistance.`,
            rw: `<h3>Amasezerano y’Ubwishingizi bw’iyi nguzanyo</h3><br>
                  Njye, niyemeje kandi nemeye ko iyi nguzanyo ikubiyemo ubwishingizi butangwa na Sanlam Vie PLC. Ubu bwishingizi bukubiyemo ibintu byihariye, birimo urupfu cyangwa ubumuga kandi buhoraho bw’uwagurijwe, hagamijwe kwishyura inguzanyo isigaye.<br><br>
                  Ndemera kandi  ko amafaranga y’ubwishingizi agengwa n’amategeko  n’amabwiriza akubiye muri iyi nyandiko  kimwe n’andi mabwirza abigenga.<br><br>
                  Nemeye ko ndamutse nkeneye ibisobanuro cyangwa amakuru yinyongera yerekeranye n’urwego cyangwa imiterere y’ubwishingizi, nshobora guhamagara uwangurije kugirango amfashe. `,
          },
        },
        {
          type: "html",
          html: {
            en: `<h3>Annual Percentage Rate (APR)</h3><br>
              I, the undersigned, acknowledge that the total cost of the loan includes interest and all applicable fees. 
              I understand that the Annual Percentage Rate (APR) represents the true cost of the loan over a one-year period, 
              expressed as a percentage of the loan amount.<br><br>
              The APR calculation considers the interest rate, administrative fees, taxes, and other applicable charges. 
              I confirm that I have reviewed and understood the APR applicable to my loan and acknowledge my full awareness of the total cost of borrowing.<br><br>
              By signing this agreement, I accept the terms of the loan, including the APR, as disclosed by MoneyPhone Africa Ltd.`,
            rw: `<h3>Ijanisha ry'inguzanyo ku mwaka</h3><br>
              Jyewe, uvugwa hano, nemeye ko igiteranyo cyose cy'inguzanyo gikubiyemo inyungu ku nguzanyo n'andi mafaranga yose akoreshwa. 
              Nsobanukiwe ko Ijanisha ry'inguzanyo ku mwaka rigaragaza igiciro nyacyo cy'inguzanyo mu gihe cy'umwaka, isobanurwa mu buryo bw' ikinyejana ku nguzanyo.<br><br>
              Umubare wa APR ugendera ku ngano y'inyungu, igiciro cya serivisi, umusoro n'andi mafaranga nkenerwa akatwa. 
              Nemeje ko nasuzumye kandi nasobanukiwe umubare wa APR ubarwa ku nguzanyo yanjye kandi nemeye igiteranyo cyose cy'igiciro cy'inguzanyo. 
              Mu gusinya iyi nyandiko, nemeye amategeko y'inguzanyo, harimo na APR, nk'uko MoneyPhone Africa Ltd ibigaragaza.`,
          },
        },
        {
          type: "html",
          visibleIf: "{loan.loan_type} == 'group'",
          html: {
            en: `<h3>Guarantor obligations</h3><br>
                I hereby acknowledge and agree to act as a joint and several guarantor together with the other four individuals participating in this loan application. I expressly undertake to guarantee the due and punctual repayment of each individual borrower’s obligations within the group.<br><br>
                In the event that any co-borrower fails to fulfil their repayment obligations in whole or in part, I shall, upon demand by the Lender, be jointly and severally liable for such outstanding amounts and shall make payment on their behalf without delay.<br><br>
                I further acknowledge that this loan constitutes a joint financial undertaking, and that the loan shall be deemed fully repaid only when all individual loan obligations within the group have been satisfied in full.`,
            rw: `<h3>Inshingano z'umwishingizi</h3><br>
                Njyewe, niyemeje kandi nemeye gukora nk'umwishingizi w’umwe cg benshi mu bantu bane twafatanyije mu gusaba inguzanyo muri iri tsinda. Niyemeje byimazeyo kwemeza ko ubwishyu bukwiye buzajya butangwa kandi bwubahirije igihe kuri buri munyamurwango w’iri tsinda wagurijwe.<br><br>
                Mugihe mugenzi wanjye wagurijwe wese adashoboye kubahiriza inshingano zo kwishyura zose cyangwa yazubahirije by’igice, kandi mbisabwe n’uwaduhaye inguzanyo, nzabazwa ayo mafaranga ya bagenzi banjye kandi nkayishyura mw’izina ryabo kandi bidatinze.<br><br>
                Nongeye kandi kwemeza ko iyi nguzanyo ari inguzanyo ihuriweho, kandi ko iyo inguzanyo izafatwa nk’aho yishyuwe byuzuye mugihe ubwishyu bwose bwa buri munyamurango w’itsinda bwatanzwe uko bwakabaye.`,
          },
        },
        {
          type: "html",
          html: {
            en: `<h3>Environmental and Social Responsibility</h3><br>
              The Borrower commits to conduct all activities in compliance with applicable environmental and social standards, 
              and shall not engage in practices that cause harm to the environment, community health, safety, or social well-being.`,
            rw: `<h3>Inshingano ku muryango mugari n'ibidukikije</h3><br>
              Uwagurijwe yiyemeje gukora ibikorwa byose yubahiriza ibipimo n'amabwiriza ngenderwaho by'ibidukikije n'imibereho myiza kandi
              ntashobora gukora ibikorwa byangiza ibidukikije, ubuzima bw’abaturage, umutekano, cyangwa imibereho myiza y'abaturage.`,
          },
        },
        {
          title: "Agree to micro insurance programs",
          titleLocation: "none",
          type: "checkbox",
          name: "agreeMicroInsuranceProgramms",
          isRequired: true,
          choices: [
            {
              value:
                "Applicant has agreed to micro insurance programs in the review flow.",
              text: {
                en: "I agree",
                rw: "Ndabyemeye",
              },
            },
          ],
          validators: [],
        },
      ],
    },
  ],
};

const subject_to_changes = {
  type: "html",
  name: "subject_to_changes",
  html: {
    en: `This contract may be subject to changes until the final assessment stage.`,
    rw: `Aya masezerano arashobora guhinduka kugeza kurangiza icyiciro cyo gusuzuma.`,
  },
};

export const review_rwanda_direct_model_default = {
  showProgressBar: "top",
  showQuestionNumbers: "off",
  sendResultOnPageNext: true,

  firstPageIsStarted: false,

  showCompletedPage: false,
  completeText: {
    en: "Submit loan application",
    rw: "Ohereza",
  },

  questionStartIndex: 1,
  requiredText: "",

  pages: [
    // Page 1: Terms and conditions
    terms_and_conditions,
    // Page 2: Review
    {
      title: {
        en: "Review your loan application",
        rw: "Subiramo neza ubusabe bwawe",
      },
      name: "review",
      innerIndent: 1,

      elements: [
        {
          name: "total_overview",
          type: "panel",
          visibleIf: "{amount} notempty and {loan.repayment_period} notempty",
          elements: [
            {
              name: "loan_terms",
              valueName: "loan_terms",
              type: "expression",
              expression: "loan_terms", // Floating Point Proof
              title: "Technical loan terms (NOT visible for user)",
              visibleIf: "{amount} < 0",
            },
            {
              title: {
                en: "Requested loan amount in RWF",
                rw: "Amafaranga y'inguzanyo asabwa",
              },
              type: "expression",
              expression: "{amount}", // Floating Point Proof
            },
            {
              title: {
                en: "Loan term (in months)",
                rw: "Igihe iguzanyo izamara (Mu mezi)",
              },
              name: "custom_float_2",
              type: "expression",
              expression: "{loan.repayment_period}", // Floating Point Proof
            },
            {
              title: {
                en: "Total administrative fees in RWF to be deducted from the loan amount ({admin_fee})",
                rw: "Umufuragiro mu RWF akurwa ku nguzanyo yemejwe ({admin_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_1.total}",
            },
            {
              title: {
                en: "Total VAT on administrative fees in RWF to be deducted from the loan amount ({vat_on_admin_fee})",
                rw: "Umusoro(VAT) kumufuragiro akurwa kunguzanyo yemejwe  ({vat_on_admin_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_2.total}", // This will be done with on-page calculation like Credicapital
            },
            {
              title: {
                en: "Insurance fees in RWF to be deducted from the loan amount ({insurance_fee})",
                rw: "Amafaranga y'ubwishingizi akurwa kunguzanyo yemejwe ({insurance_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_3.total}",
            },
            {
              title: {
                en: "Loan interest in RWF ({product_interest_rate}% per year)",
                rw: "Inyungu ku ngunzanyo mu mwaka mu RWF ({product_interest_rate}% ku mwaka)",
              },
              name: "custom_float_1",
              type: "expression",
              expression: "{total_interest}", // Floating Point Proof
            },
            {
              title: {
                en: "Total loan amount to be disbursed: approved loan amount minus fees",
                rw: "Amafaranga azagera kuri konti yawe",
              },
              name: "custom_float_6",
              type: "expression",
              expression:
                "fixed(subtract({loan.amount},{charge_dict.charge_code_1.total},{charge_dict.charge_code_2.total},{charge_dict.charge_code_3.total})", // Floating Point Proof
            },
            {
              title: {
                en: "Total loan amount to be repaid: approved loan amount plus interest",
                rw: "Amafaranga y’inguzanyo yemejwe wongeyeho inyungu",
              },
              name: "custom_float_7",
              type: "expression",
              expression: "fixed(add({loan.amount}, {total_interest}", // Floating Point Proof
            },
            {
              title: {
                en: "Annual Percentage Rate (APR) %",
                rw: "Ijanisha ry'inguzanyo ku mwaka %",
              },
              type: "expression",
              expression: "fixed({annual_percentage_rate}", // Floating Point Proof
            },
            {
              title: {
                en: "Cooking Stove",
                rw: "Imbabura ya kijyambere",
              },
              type: "expression",
              visibleIf: "{loan.intake.custom_bool_3} = true",
              expression: "{loan.intake.cooking_stove_amount}",
            },
            {
              visibleIf: "{loan.intake.custom_bool_3} = true",
              type: "panel",
              title: {
                en: "Cooking Stove",
                rw: "Imbabura ya kijyambere",
              },
              elements: [
                {
                  type: "html",
                  html: {
                    en: `By selecting the option to include a cooking stove in the loan application, an amount of RWF {cooking_stove_amount} will be deducted from the amount disbursed allocated for the cooking stove. The farmer acknowledges that this amount is non-refundable and will be directly allocated for the purchase of the cooking stove as part of the loan agreement.`,
                    rw: `Mu guhitamo uburyo bwo guhabwa imbabura ya kijyambere mu busabe bw'inguzanyo, igiciro cya {cooking_stove_amount}rwf kirakurwa ku mafaranga y'inguzanyo agenerwe imbabura ya kijyambere . Umuhinzi aremeza ko aya mafaranga adasubizwa kandi ko azaba ajyenewe mu kugura imbabura ya kijyambere nka kimwe mu bikubiye mu masezerano y'inguzanyo.`,
                  },
                },
              ],
            },
          ],
        },
        {
          type: "html",
          visibleIf: "{repayment_period} != 12",
          html: {
            en: `<h5 class="sv_q_title">
                  You are committing to a {repayment_period} months payment of {principal_amount} RWF. You are aware that you will need to repay the
                  whole loan of {principal_amount} RWF plus {custom_float_1} RWF in interest.
                </h5>`,
            rw: `<h5 class="sv_q_title">
                  Niyemeje kwishyura amafaranga nyuma y'amezi {repayment_period} amafaranga angana na {principal_amount} RWF hinyongereyeho
                  {custom_float_1} RWF in y'inyungu
                </h5>`,
          },
        },
        {
          type: "html",
          visibleIf: "{repayment_period} == 12",
          html: {
            en: `<h5 class="sv_q_title">
                  The borrower commits to repay {monthly_installment} RWF, half the amount of the loan and interest within 6 months from the date of signing and 
                  {monthly_installment} RWF, the other half of the loan and interest within 12 months of signing.
                  </h5>`,
            rw: `<h5 class="sv_q_title">
                  Niyemeje kwishyura {monthly_installment} RWF, kimwe cyakabiri cy’inguzanyo n'inyungu mu mezi atandatu guhera na {monthly_installment} RWF,
                  ikindi gice cy’inguzanyo n’inyungu mu mezi 12 .
                  </h5>`,
          },
        },
        {
          type: "html",
          name: "penalty",
          html: {
            en: `To ensure that you are serious about a timely monthly payment, you will be charged {late_fee_per_month}% RWF for every month you are
                  late with payment.`,
            rw: `Kugirango twizere ko uzubahiriza  igihe cy'ubwishyu bwa buri kwezi, mugihe watinze kwishyura uzajya ucibwa amande
                  ya {late_fee_per_month}% RWF`,
          },
        },
        subject_to_changes,
        {
          type: "html",
          name: "joint_guarantor",
          visibleIf: "{loan.loan_type} == 'group'",
          html: {
            en: `I agree to act as a joint guarantor with the other group members. If any member fails to repay, I accept joint responsibility for the outstanding amount until the total group loan is fully settled.`,
            rw: `Nemeye gukora nk'umwishingizi uhuriweho n'abandi bagize itsinda. 
              Niba hari umunyamuryango wananiwe kwishyura, nemera inshingano zihuriweho zo kwishyura amafranga  asigaye kugeza inguzanyo y’itsinda ryose yishyuwe.`,
          },
        },
        i_agree,
      ],
    },
  ],
};

export const review_rwanda_direct_model_chili = {
  showProgressBar: "top",
  showQuestionNumbers: "off",
  sendResultOnPageNext: true,

  firstPageIsStarted: false,

  showCompletedPage: false,
  completeText: {
    en: "Submit loan application",
    rw: "Ohereza",
  },

  questionStartIndex: 1,
  requiredText: "",

  pages: [
    // Page 1: Terms and conditions
    terms_and_conditions,
    // Page 2: Review and sign
    {
      title: {
        en: "Review your loan application",
        rw: "Subiramo neza ubusabe bwawe",
      },
      name: "review",
      innerIndent: 1,

      elements: [
        {
          name: "total_overview",
          type: "panel",
          visibleIf: "{amount} notempty and {loan.repayment_period} notempty",
          elements: [
            current_date,
            {
              name: "loan_terms",
              valueName: "loan_terms",
              type: "expression",
              expression: "loan_terms", // Floating Point Proof
              title: "Technical loan terms (NOT visible for user)",
              visibleIf: "{amount} < 0",
            },
            {
              title: {
                en: "Requested loan amount in RWF",
                rw: "Amafaranga y'inguzanyo asabwa",
              },
              type: "expression",
              expression: "{amount}",
            },
            {
              title: {
                en: "Loan term (in months)",
                rw: "Igihe iguzanyo izamara (Mu mezi)",
              },
              name: "repayment_period",
              type: "expression",
              expression: "{loan.repayment_period}", // Floating Point Proof
            },
            {
              title: {
                en: "Total administrative fees in RWF to be deducted from the loan amount ({admin_fee})",
                rw: "Amafaranga ya serivise y'ubuyobozi angana na {admin_fee} akurwa kunguzanyo yemejwe",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_1.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Total VAT on administrative fees in RWF to be deducted from the loan amount ({vat_on_admin_fee})",
                rw: "Umusoro(VAT) ukurwa kunguzanyo yemejwe ({vat_on_admin_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_2.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Insurance fees in RWF to be deducted from the loan amount ({insurance_fee})",
                rw: "Amafaranga y'ubwishingizi akurwa kunguzanyo yemejwe ({insurance_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_3.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Loan interest in RWF ({product_interest_rate}% per year)",
                rw: "Inyungu ku ngunzanyo mu mwaka mu RWF ({product_interest_rate}% ku mwaka)",
              },
              name: "custom_float_5",
              type: "expression",
              expression: "{total_interest}", // Floating Point Proof
            },
            {
              title: {
                en: "Total loan amount to be disbursed: approved loan amount minus fees",
                rw: "Igiteranyo cy'Amafaranga yinguzanyo yemejwe gutangwa",
              },
              name: "custom_float_6",
              type: "expression",
              expression:
                "fixed(subtract({loan.amount},{charge_dict.charge_code_1.total},{charge_dict.charge_code_2.total},{charge_dict.charge_code_3.total})", // Floating Point Proof
            },
            {
              title: {
                en: "Total loan amount to be repaid: approved loan amount plus interest",
                rw: "Igiteranyo cy' Amafaranga yinguzanyo yemejwe gusubizwa",
              },
              name: "custom_float_7",
              type: "expression",
              expression: "fixed(add({loan.amount}, {total_interest}", // Floating Point Proof
            },
            {
              title: {
                en: "Annual Percentage Rate (APR) %",
                rw: "Ijanisha ry'inguzanyo ku mwaka %",
              },
              type: "expression",
              expression: "fixed({annual_percentage_rate}", // Floating Point Proof
            },
            {
              title: {
                en: "Cooking Stove",
                rw: "Imbabura ya kijyambere",
              },
              type: "expression",
              visibleIf: "{loan.intake.custom_bool_3} = true",
              expression: "{loan.intake.cooking_stove_amount}",
            },
            {
              visibleIf: "{loan.intake.custom_bool_3} = true",
              type: "panel",
              title: {
                en: "Cooking Stove",
                rw: "Imbabura ya kijyambere",
              },
              elements: [
                {
                  type: "html",
                  html: {
                    en: `By selecting the option to include a cooking stove in the loan application, an amount of RWF {cooking_stove_amount} will be deducted from the amount disbursed allocated for the cooking stove. The farmer acknowledges that this amount is non-refundable and will be directly allocated for the purchase of the cooking stove as part of the loan agreement.`,
                    rw: `Mu guhitamo uburyo bwo guhabwa imbabura ya kijyambere mu busabe bw'inguzanyo, igiciro cya {cooking_stove_amount}rwf kirakurwa ku mafaranga y'inguzanyo agenerwe imbabura ya kijyambere . Umuhinzi aremeza ko aya mafaranga adasubizwa kandi ko azaba ajyenewe mu kugura imbabura ya kijyambere nka kimwe mu bikubiye mu masezerano y'inguzanyo.`,
                  },
                },
              ],
            },
          ],
        },
        {
          type: "html",
          visibleIf: "{loan.repayment_period} != 12",
          html: {
            en: `<h5 class="sv_q_title">
                  The borrower authorizes the cooperative to automatically deduct the amount corresponding to the loan
                  repayment directly from the production income.
                  <br><br>
                  The amount should be repaid within {repayment_period} months from the date of signing {today_date}.
                </h5>`,
            rw: `<h5 class="sv_q_title">
                  Uwagurijwe yemerera koperative guhita ikuramo amafaranga ahuye no kwishyura inguzanyo biturutse ku musaruro. 
                  <br><br>
                  Amafaranga agomba kwishyurwa mugihe cyamezi {repayment_period} uhereye umunsi wasinyiye {today_date}.
                </h5>`,
          },
        },
        {
          type: "html",
          visibleIf: "{repayment_period} == 12",
          html: {
            en: `<h5 class="sv_q_title">
                  The borrower commits to repay {monthly_installment} RWF, half the amount of the loan and interest within 6 months from the date of signing {today_date} and 
                  {monthly_installment} RWF, the other half of the loan and interest within 12 months of signing.
                  </h5>`,
            rw: `<h5 class="sv_q_title">
                  Niyemeje kwishyura {monthly_installment} RWF, kimwe cyakabiri cy’inguzanyo n'inyungu mu mezi atandatu guhera {today_date} na {monthly_installment} RWF,
                  ikindi gice cy’inguzanyo n’inyungu mu mezi 12.
                  </h5>`,
          },
        },
        {
          type: "html",
          name: "penalty",
          html: {
            en: `To ensure that you are serious about a timely monthly payment, you will be charged {late_fee_per_month}% RWF for every month you
                  are late with payment.`,
            rw: `Kugirango twizere ko uzubahiriza igihe cy'ubwishyu bwa buri kwezi, mugihe watinze kwishyura uzajya ucibwa amande
                  ya {late_fee_per_month}% RWF`,
          },
        },
        subject_to_changes,
        i_agree,
      ],
    },
  ],
};

export const review_rwanda_direct_model_monthly_payment = {
  showProgressBar: "top",
  showQuestionNumbers: "off",
  sendResultOnPageNext: true,

  firstPageIsStarted: false,

  showCompletedPage: false,
  completeText: {
    en: "Submit loan application",
    rw: "Ohereza",
  },

  questionStartIndex: 1,
  requiredText: "",

  pages: [
    // Page 1: Terms and conditions
    terms_and_conditions,
    // Page 2: Review and sign
    {
      title: {
        en: "Review your loan application",
        rw: "Subiramo neza ubusabe bwawe",
      },
      name: "review",
      innerIndent: 1,

      elements: [
        {
          name: "total_overview",
          type: "panel",
          visibleIf: "{amount} notempty and {loan.repayment_period} notempty",
          elements: [
            {
              name: "loan_terms",
              valueName: "loan_terms",
              type: "expression",
              expression: "loan_terms", // Floating Point Proof
              title: "Technical loan terms (NOT visible for user)",
              visibleIf: "{amount} < 0",
            },
            {
              title: {
                en: "Requested loan amount in RWF",
                rw: "Amafaranga y'inguzanyo asabwa",
              },
              type: "expression",
              expression: "{amount}",
            },
            {
              title: {
                en: "Loan term (in months)",
                rw: "Igihe iguzanyo izamara (Mu mezi)",
              },
              name: "repayment_period",
              type: "expression",
              expression: "{loan.repayment_period}", // Floating Point Proof
            },
            {
              title: {
                en: "Total administrative fees in RWF to be deducted from the loan amount ({admin_fee})",
                rw: "Amafaranga ya serivise y'ubuyobozi angana na {admin_fee} akurwa kunguzanyo yemejwe",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_1.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Total VAT on administrative fees in RWF to be deducted from the loan amount ({vat_on_admin_fee})",
                rw: "Umusoro(VAT) ukurwa kunguzanyo yemejwe ({vat_on_admin_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_2.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Insurance fees in RWF to be deducted from the loan amount ({insurance_fee})",
                rw: "Amafaranga y'ubwishingizi akurwa kunguzanyo yemejwe ({insurance_fee})",
              },
              type: "expression",
              expression: "{charge_dict.charge_code_3.total}", // Floating Point Proof
            },
            {
              title: {
                en: "Loan interest in RWF ({product_interest_rate}% per year)",
                rw: "Inyungu ku ngunzanyo mu mwaka mu RWF ({product_interest_rate}% ku mwaka)",
              },
              name: "custom_float_5",
              type: "expression",
              expression: "{total_interest}", // Floating Point Proof
            },
            {
              title: {
                en: "Total loan amount to be disbursed: approved loan amount minus fees",
                rw: "Igiteranyo cy'Amafaranga yinguzanyo yemejwe gutangwa",
              },
              name: "custom_float_6",
              type: "expression",
              expression:
                "fixed(subtract({loan.amount},{charge_dict.charge_code_1.total},{charge_dict.charge_code_2.total},{charge_dict.charge_code_3.total})", // Floating Point Proof
            },
            {
              title: {
                en: "Total loan amount to be repaid: approved loan amount plus interest",
                rw: "Igiteranyo cy' Amafaranga yinguzanyo yemejwe gusubizwa",
              },
              name: "custom_float_7",
              type: "expression",
              expression: "fixed(add({loan.amount}, {total_interest}", // Floating Point Proof
            },
            {
              title: {
                en: "Annual Percentage Rate (APR) %",
                rw: "Ijanisha ry'inguzanyo ku mwaka %",
              },
              type: "expression",
              expression: "fixed({annual_percentage_rate}", // Floating Point Proof
            },
            {
              title: {
                en: "Monthly amount",
                rw: "Ubwishyu bwa buri kwezi",
              },
              name: "custom_float_8",
              type: "expression",
              expression:
                "fixed(divide({custom_float_7}, {loan.repayment_period}))",
            },
            {
              title: {
                en: "Cooking Stove",
                rw: "Imbabura ya kijyambere",
              },
              type: "expression",
              visibleIf: "{loan.intake.custom_bool_3} = true",
              expression: "{loan.intake.cooking_stove_amount}",
            },
            {
              visibleIf: "{loan.intake.custom_bool_3} = true",
              type: "panel",
              title: {
                en: "Cooking Stove",
                rw: "Imbabura ya kijyambere",
              },
              elements: [
                {
                  type: "html",
                  html: {
                    en: `By selecting the option to include a cooking stove in the loan application, an amount of RWF {cooking_stove_amount} will be deducted from the amount disbursed allocated for the cooking stove. The farmer acknowledges that this amount is non-refundable and will be directly allocated for the purchase of the cooking stove as part of the loan agreement.`,
                    rw: `Mu guhitamo uburyo bwo guhabwa imbabura ya kijyambere mu busabe bw'inguzanyo, igiciro cya {cooking_stove_amount}rwf kirakurwa ku mafaranga y'inguzanyo agenerwe imbabura ya kijyambere . Umuhinzi aremeza ko aya mafaranga adasubizwa kandi ko azaba ajyenewe mu kugura imbabura ya kijyambere nka kimwe mu bikubiye mu masezerano y'inguzanyo.`,
                  },
                },
              ],
            },
          ],
        },
        {
          type: "html",
          html: {
            en: `<h5 class="sv_q_title">
                  Over the {repayment_period} month period, you will make monthly payments in the amount of {custom_float_8} RWF.
                  You are aware that you will have to repay the full loan amount of {amount} RWF plus {custom_float_5} RWF for
                  expenses.
                  <br><br>
                  You authorise the cooperative to automatically deduct the amount corresponding to the monthly loan
                  repayment directly from the production income.
                </h5>`,
            rw: `<h5 class="sv_q_title">
                  Mugihe cy'amezi {repayment_period}, uzajya wishyura buri kwezi amafaranga angana na {custom_float_8} RWF. Uzishyura
                  amafaranga yose angana na {amount} RWF n'inyungu {custom_float_5} RWF.
                  <br><br>
                  Mpaye uburenganzira koperative bwo gukuraho amafaranga y'ubwishyu bw'inguzanyo bwa buri kwezi kumafaranga
                  yishyuwe kumusararuro wanjye.
                </h5>`,
          },
        },
        {
          type: "html",
          name: "penalty",
          html: {
            en: `To ensure that you are serious about a timely monthly payment, you will be charged {late_fee_per_month}% RWF for every month you
                  are late with payment.`,
            rw: `Kugirango twizere ko uzubahiriza igihe cy'ubwishyu bwa buri kwezi, mugihe watinze kwishyura uzajya ucibwa amande
                  ya {late_fee_per_month}% RWF`,
          },
        },
        subject_to_changes,
        i_agree,
      ],
    },
  ],
};
